import type { FC, MouseEventHandler } from 'react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ReplayRounded from '@mui/icons-material/ReplayRounded';
import { Button, Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

interface ErrorOverlayWithRefetchButtonProps {
  errorMsg: string;
  refetch?: () => void;
  name?: string;
}

const ErrorOverlayWithRefetchButton: FC<ErrorOverlayWithRefetchButtonProps> = ({
  errorMsg,
  refetch,
  name,
}) => {
  const { t } = useTranslation('common');
  const handleClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault();
      refetch?.();
    },
    [refetch],
  );
  return (
    <Stack spacing={1} sx={styles.wrapper}>
      {name && (
        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            alignSelf: 'flex-start',
          }}
        >
          {name}
        </Typography>
      )}
      <Stack
        direction="column"
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
          }}
        >
          {errorMsg}
        </Typography>
        {refetch && (
          <Button
            startIcon={<ReplayRounded />}
            onClick={handleClick}
            variant="text"
            color="inherit"
          >
            {t('common:tryAgain')}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default ErrorOverlayWithRefetchButton;
